module.exports = __webpack_public_path__ + "media/loginBgVideo.0fdaecd5.mp4";